import {setPrintingAction} from 'app/modules/printingHandler/store/actions';

export const initPrintingHandler = () => {
    window.addEventListener('beforeprint', () => {
        setPrintingAction(true);
    });

    window.addEventListener('afterprint', () => {
        setPrintingAction(false);
    });
};
